import { render } from "./VWeeklyTreatment.vue?vue&type=template&id=275beee0"
import script from "./VWeeklyTreatment.vue?vue&type=script&lang=js"
export * from "./VWeeklyTreatment.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__